export default "__VITE_ASSET__BatXyVLP__"